import { render, staticRenderFns } from "./NumberCenter.vue?vue&type=template&id=f8a053da&scoped=true"
import script from "./NumberCenter.vue?vue&type=script&lang=js"
export * from "./NumberCenter.vue?vue&type=script&lang=js"
import style0 from "./NumberCenter.vue?vue&type=style&index=0&id=f8a053da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a053da",
  null
  
)

export default component.exports